<template>
    <div id="class" @click="showDetail = !showDetail">
        <div class="row align-space-between">
            <p style="font-size: 28px; font-weight: bold">{{ title }}</p>
            <input
                type="checkbox"
                v-model="isCheck"
                @change="selectClass"
                style="width: 42px; height: 42px"
            />
        </div>
        <div class="row align-space-between" style="margin-top: 16px">
            <p style="font-size: 20px; font-weight: normal; color: #5f5f5f">
                {{ enrollAndCapacity }}
            </p>
            <p style="font-size: 20px; font-weight: normal; color: #5f5f5f">
                {{ formatKoreanDate(date) }}
            </p>
        </div>
        <div v-show="showDetail" class="detail">
            <div class="row" style="gap: 16px">
                <p style="font-size: 16px; font-weight: bold">교육장소</p>
                <p style="font-size: 16px; font-weight: bold">:</p>
                <p style="font-size: 16px">{{ lecture.location.replace(':', ' ') }}</p>
            </div>
            <div class="row" style="gap: 16px">
                <p style="font-size: 16px; font-weight: bold">교육시간</p>
                <p style="font-size: 16px; font-weight: bold">:</p>
                <p style="font-size: 16px">
                    {{ lecture.start_time }} ~ {{ lecture.end_time }}
                </p>
            </div>
            <div class="row" style="gap: 16px">
                <p style="font-size: 16px; font-weight: bold; width: auto">
                    교육내용
                </p>
                <p style="font-size: 16px; font-weight: bold">:</p>
                <p style="font-size: 16px; width: 90%">
                    {{ lecture.detail }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref, onMounted, onUpdated } from "vue";

export default defineComponent({
    props: {
        title: {
            type: String,
            default: "",
        },
        enrollAndCapacity: {
            type: String,
            default: "",
        },
        date: {
            type: String,
            default: "",
        },
        checked: {
            type: Boolean,
            default: false,
        },
        classId: {
            type: Number,
            default: 0,
        },

        lecture: {
            type: Object,
        },

        onClick: Function,
    },
    setup(props, { emit }) {
        const isCheck = ref(false);

        onMounted(() => {
            isCheck.value = props.checked;
        });

        onUpdated(() => {
            isCheck.value = props.checked;
        });
        const formatKoreanDate = (dateString) => {
            const date = new Date(dateString);
            return date
                .toLocaleDateString("ko-KR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                })
                .replace(/\. /g, "-")
                .slice(0, -1); // 한국 형식은 보통 "YYYY. MM. DD." 이므로 이를 변환합니다.
        };

        const selectClass = () => {
            emit("checked", props.classId);
        };

        const showDetail = ref(false);

        return {
            isCheck,
            selectClass,
            showDetail,formatKoreanDate
        };
    },
});
</script>

<style scoped>
button {
    padding: 8px 16px;
    border: 0.5px solid black;
    border-radius: 20px;
}

#class {
    width: 100%;
    padding: 16px 24px;
    border-bottom: 1px solid #b3b3b3;
    cursor: pointer;
}

.detail {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 30px;
    gap: 16px;
}
</style>
